var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 17 22",
    style: {
      enableBackground: "new 0 0 17 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,0.1c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0H6.6c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6,6.9c0.5,0,0.9,0.4,1,0.9l0,0.1v9c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1v-9 C5.6,7.3,6.1,6.9,6.6,6.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10,6.9c0.5,0,0.9,0.4,1,0.9l0,0.1v9c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1v-9 C9,7.3,9.4,6.9,10,6.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6,2.9c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0H1c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H15.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.5c0.5,0,0.9,0.4,1,0.9l0,0.1 V20c0,0.5-0.4,0.9-0.9,1l-0.1,0H2.1c-0.5,0-0.9-0.4-1-0.9l0-0.1V6.7c0-0.6,0.4-1,1-1c0.5,0,0.9,0.4,1,0.9l0,0.1l0,12.3h10.3l0-12.5 c0-0.5,0.4-0.9,0.9-1L14.5,5.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0ec60888ecb85e24ba6d14fdb5b80184.svg";
export { ForwardRef as ReactComponent };